import React from 'react';
import { useAppContext } from '../contexts/AppContext';

const AdminPage = () => {
  const {
    adminFeedback, adminLoading, adminFilter, setAdminFilter,
    loadAdminFeedback, markFeedbackReviewed,
  } = useAppContext();

  const filtered = adminFilter === 'all' ? adminFeedback
    : adminFilter === 'unreviewed' ? adminFeedback.filter(f => !f.reviewed)
    : adminFeedback.filter(f => f.reviewed);

  const avgRating = adminFeedback.length > 0
    ? (adminFeedback.reduce((sum, f) => sum + f.rating, 0) / adminFeedback.length).toFixed(1)
    : '—';

  return (
    <div>
      <div className="page-header">
        <h2> Beta Feedback</h2>
        <p>All user feedback from the closed beta. {adminFeedback.length} submissions total.</p>
      </div>

      {/* Stats row */}
      <div className="stats-grid" style={{ gridTemplateColumns: 'repeat(4, 1fr)' }}>
        <div className="stat-card"><div className="stat-num">{adminFeedback.length}</div><div className="stat-label">Total</div></div>
        <div className="stat-card"><div className="stat-num">{adminFeedback.filter(f => !f.reviewed).length}</div><div className="stat-label">Unreviewed</div></div>
        <div className="stat-card"><div className="stat-num">{avgRating}</div><div className="stat-label">Avg Rating</div></div>
        <div className="stat-card"><div className="stat-num">{[...new Set(adminFeedback.map(f => f.userId))].length}</div><div className="stat-label">Users</div></div>
      </div>

      {/* Filter bar */}
      <div className="feedback-filter-bar">
        {[
          { id: 'all', label: 'All' },
          { id: 'unreviewed', label: 'Unreviewed' },
          { id: 'reviewed', label: 'Reviewed' },
        ].map(f => (
          <button key={f.id} className="feedback-filter-btn" onClick={() => setAdminFilter(f.id)}
            style={{
              background: adminFilter === f.id ? 'rgba(15,23,42,0.08)' : '#fff',
              borderColor: adminFilter === f.id ? 'rgba(15,23,42,0.25)' : 'rgba(15,23,42,0.1)',
              color: adminFilter === f.id ? '#0f172a' : '#7a6b5a',
            }}>
            {f.label} {f.id === 'unreviewed' ? `(${adminFeedback.filter(fb => !fb.reviewed).length})` : ''}
          </button>
        ))}
        <button className="feedback-filter-btn" onClick={loadAdminFeedback}
          style={{ marginLeft: 'auto', background: 'rgba(39,174,96,0.1)', borderColor: 'rgba(39,174,96,0.3)', color: '#217a3e' }}>
          ↻ Refresh
        </button>
      </div>

      {/* Feedback cards */}
      {adminLoading ? (
        <div className="empty-state">Loading feedback...</div>
      ) : filtered.length === 0 ? (
        <div className="empty-state">No feedback to show.</div>
      ) : (
        filtered.map(fb => (
          <div key={fb.id} className={`feedback-card${fb.reviewed ? ' reviewed' : ''}`}>
            <div className="feedback-card-header">
              <div>
                <div className="feedback-card-stars">{'★'.repeat(fb.rating)}{'☆'.repeat(5 - fb.rating)}</div>
                <div className="feedback-card-meta">{fb.displayName} · {new Date(fb.createdAt).toLocaleString()}</div>
              </div>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <span className="feedback-card-tab">{fb.currentTab}</span>
                {fb.reviewed && <span style={{ fontSize: '1.05rem', color: 'rgba(104,211,145,0.7)', fontFamily: "'Lora', serif", letterSpacing: '1px' }}>✓ REVIEWED</span>}
              </div>
            </div>
            {fb.comment && <div className="feedback-card-comment">{fb.comment}</div>}
            {!fb.reviewed && (
              <button className="btn btn-ghost" style={{ fontSize: '1rem', padding: '6px 14px' }} onClick={() => markFeedbackReviewed(fb.id)}>
                Mark as Reviewed
              </button>
            )}
          </div>
        ))
      )}
    </div>
  );
};

export default AdminPage;
